import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import { Provider as ContextProvider } from "./context/globalContext";
import { graphQLClient } from "./helpers/graphqlClient";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "styled-components";
import { ThemeProps as theme } from "./app/genericComponents/globalStyles";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import "semantic-ui-css/semantic.min.css";
import "./helpers/initializeServices";
import "antd/dist/antd.css";
import "./app/genericComponents/global.scss";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={graphQLClient}>
      <ContextProvider value={{ graphQLClient }}>
        <ThemeProvider theme={theme}>
          <Router>
            <App />
          </Router>
        </ThemeProvider>
      </ContextProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
